import { useMutationBuilder, useQueryBuilder } from "../useBuilders";
import { FETCH, UPDATE, VIEWER_SETTINGS } from "../queryKeys";
import { viewerSettingsApi } from "src/services/settings/viewerSettings";

export const useAccountFetch = () => {
  return useQueryBuilder([VIEWER_SETTINGS, FETCH], viewerSettingsApi.fetchAccount, false, 1 * 60 * 1000, "always");
};

export const useUpdateAccount = () => {
  return useMutationBuilder([VIEWER_SETTINGS, UPDATE], viewerSettingsApi.updateAccount, [VIEWER_SETTINGS, FETCH]);
};
